import React from 'react'
import { connect } from 'react-redux'
import { Map, Marker, GoogleApiWrapper } from 'google-maps-live-react'
import { TextField } from 'redux-form-material-ui'
import { Field, change } from 'redux-form'
import RaisedButton from 'material-ui/RaisedButton'
import { geolocated } from 'react-geolocated'
import { checkinDone } from '../../../../actions'
import { missionPLatField, missionPLngField } from '../../../../utils/constants'

const styles = {
  map: {
    position: 'relative',
    width: '100%',
    height: '400px',
    overflow: 'hidden',
  },
  containerStyle: {
    width: '100%',
    height: '100%',
  },
  infoGeolocation: {
    fontSize: '14px',
    color: 'grey',
    fontStyle: 'italic',
  },
}

class CheckinPage extends React.Component {

  getLocation = () => {
    if (!this.props.isGeolocationAvailable) {
      return (<p style={styles.infoGeolocation}>
                Tu browser no soporta Geolocalización, prueba usando una versión resiente de Chrome.
              </p>)
    } else if (!this.props.isGeolocationEnabled) {
      return (<p style={styles.infoGeolocation}>
        {'Tienes desactivada la geolocalización, por favor activala. Puedes revisar '}
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="http://es.wikihow.com/cambiar-la-configuraci%C3%B3n-de-ubicaci%C3%B3n-en-Google-Chrome"
        >como activar en chrome aquí.</a>
      </p>)
    } else if (!this.props.coords) {
      return (<p style={styles.infoGeolocation}>
                Calculando geolocalización
              </p>)
    }
    return (<p style={styles.infoGeolocation}>
              Geolocalización lista.
            </p>)
  }

  geoLocationReady = () =>
    this.props.isGeolocationAvailable && this.props.isGeolocationEnabled && this.props.coords

  currentPosition = () => {
    const { real_answer } = this.props
    if (real_answer && real_answer.page_elements && real_answer.page_elements[0]) {
      const { lat, lon } = real_answer.page_elements[0]
      if (lat && lon) {
        return {
          lat,
          lng: lon,
        }
      }
    }
    return {
      lat: (this.props.coords || { latitude: 0 }).latitude,
      lng: (this.props.coords || { longitude: 0 }).longitude,
    }
  }

  performCheckin = () => {
    this.props.change(missionPLatField(this.props.mission_page), this.props.coords.latitude)
    this.props.change(missionPLngField(this.props.mission_page), this.props.coords.longitude)
  }

  zoom = () => {
    if (this.geoLocationReady()) {
      return 14
    }
    return 1
  }

  render() {
    const { mission_page, real_answer } = this.props
    return (
      <div >
        <div style={styles.map}>
          { this.getLocation() }
          <Map
            position={this.currentPosition()}
            containerStyle={styles.containerStyle}
            google={this.props.google}
            centerAroundCurrentLocation
            zoom={this.zoom()}
            center={this.currentPosition()}
          >
            <Marker position={this.currentPosition()} />
          </Map>
        </div>
        <Field
          ref={(input) => { this.latInput = input }}
          name={missionPLatField(mission_page)}
          component={TextField}
          style={{ display: 'none' }}
        />
        <Field
          ref={(input) => { this.lngInput = input }}
          name={missionPLngField(mission_page)}
          component={TextField}
          style={{ display: 'none' }}
        />
        {
          !!(real_answer && real_answer.page_elements && real_answer.page_elements[0])
          || (
            <RaisedButton
              style={{ marginTop: '10px' }}
              label="Realizar Checkin" fullWidth primary
              onTouchTap={this.performCheckin}
              disabled={!this.geoLocationReady()}
            />
          )
        }
      </div>
    )
  }

}

CheckinPage.propTypes = {
  mission_page: React.PropTypes.shape({
    id: React.PropTypes.number.isRequired,
  }).isRequired,
  google: React.PropTypes.shape({}),
  change: React.PropTypes.func.isRequired,
  coords: React.PropTypes.shape({
    latitude: React.PropTypes.number,
    longitude: React.PropTypes.number,
  }),
  isGeolocationAvailable: React.PropTypes.bool,
  isGeolocationEnabled: React.PropTypes.bool,
}

const mapStateToProps = state => ({
  ...state,
})

const mapDispatchToProps = dispatch => ({
  change: (field, value) => {
    dispatch(checkinDone())
    dispatch(change('MissionAnswerForm', field, value))
  },
})

const CheckinPageWrapper = GoogleApiWrapper({
  apiKey: 'AIzaSyAyesbQMyKVVbBgKVi2g6VX7mop2z96jBo',
  libraries: ['places', 'visualization'],
})(CheckinPage)


const geoComponent = geolocated({
  positionOptions: {
    enableHighAccuracy: false,
  },
  userDecisionTimeout: 10000,
})(CheckinPageWrapper)

export default connect(mapStateToProps, mapDispatchToProps)(geoComponent)



// WEBPACK FOOTER //
// ./src/components/MissionShow/MissionPage/CheckinPage/index.jsx